import ActionTypes from '@ziynx/action-types';

type AdminActions = {
  type: string,
}

const initialState = {
  results: [],
  page: 0,
  pageSize: 25,
  isLastPage: false,
  fetching: false,
};

export default function reduceOriginalsList(state = initialState, action: AdminActions) {
  if (!action.type) {
    return state;
  }

  let deletedId;
  let filteredResults = state?.results;
  if (action?.id && action?.type === ActionTypes.originals.delete.SUCCESS) {
    deletedId = action?.id;
    filteredResults = state?.results?.filter((item) => item?._id !== deletedId);
  }

  switch (action.type) {
  case ActionTypes.originals.getAll.START:
    return {
      ...state,
      fetching: true,
      ...(action?.response || {}),
    };

  case ActionTypes.originals.getAll.SUCCESS:
    return {
      ...state,
      fetching: false,
      ...(action?.response || {}),
      results: action?.response?.page > 0
        ? (state?.results ?? []).concat(action?.response?.results ?? [])
        : action?.response?.results,
    };

  case ActionTypes.originals.getAll.ERROR:
    return {
      ...state,
      fetching: false,
      ...(action?.response || {}),
    };
  case ActionTypes.originals.delete.SUCCESS:
    return {
      ...state,
      results: filteredResults,
    };

  default:
    return state;
  }
}
